module.exports = __webpack_public_path__ + "static/media/TITAN.7f0ff6b2.png";